import React, { useEffect } from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from "react-redux";
import swal from "sweetalert";
import axios from 'axios';

function ResetPassword() {
    const { usernameParams } = useParams()
    const changePasswordForm = useForm()
    const navigate = useNavigate()
    const { token } = useSelector((state) => state.auth)
    const changePasswordSubmit = (data) => {
        console.log(data)
        axios.put(`${process.env.REACT_APP_SERVICE_URL}/user/password`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal({
                    title: "Başarılı!",
                    text: "Şifreniz başarıyla değiştirildi.",
                    icon: "success",
                })
                navigate('/users')
            })
            .catch((error) => {
                console.error(error)
                swal({
                    title: "Hata!",
                    text: "Şifrenizi değiştirirken bir hata oluştu.",
                    icon: "error",
                })
            })
    }

    return (
        <div className='container-fluid'>
            <HeaderTitle title='Şifre Sıfırla' description={'Şifrenizi sıfırlamak için lütfen e-posta adresinizi girin.'} />

            <div className='row'>
                <div className='col-md-6'>
                    <div className='card'>
                        <div className='card-body'>
                            <form onSubmit={changePasswordForm.handleSubmit(changePasswordSubmit)}>
                                <div className='mb-3'>
                                    <label className='form-label'>Kullanıcı Adı</label>
                                    <input type='text' className='form-control' value={usernameParams} disabled={true} />
                                </div>
                                <div className='mb-3'>
                                    <label className='form-label'>Yeni Şifre</label>
                                    <input type='password' className='form-control' {...changePasswordForm.register('password', { required: true })} />
                                    {
                                        changePasswordForm?.formState?.errors?.password && <div className='text-danger'>{changePasswordForm?.formState?.errors?.password?.message}</div>
                                    }
                                </div>
                                <div className='mb-3'>
                                    <label className='form-label'>Yeni Şifre Tekrar</label>
                                    <input type='password' className='form-control' {...changePasswordForm.register('rePassword', {
                                        required: true,
                                        validate: {
                                            matchesPreviousPassword: value => {
                                                const { password } = changePasswordForm.getValues();
                                                return password === value || "Passwords should match!";
                                            }
                                        }
                                    })} />
                                    {
                                        changePasswordForm?.formState?.errors?.rePassword && <div className='text-danger'>{changePasswordForm?.formState?.errors?.rePassword?.message}</div>
                                    }
                                </div>
                                <div className='mb-3'>
                                    <input type='hidden' value={usernameParams} {...changePasswordForm.register('username', { required: true })} />
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Şifremi sıfırla</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword